import { StandardAreaForm } from '../types/standardArea.types';

export const DEFAULT_FORM: StandardAreaForm = {
    seqNo: null,
    areaName: '',
    selectedSuppIds: [],
};
